import React, { useContext, useEffect, useState } from "react";
import { Sidebar } from "primereact/sidebar";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { ToastContext } from "../../App";
import { useLogoutMutation } from "../../redux/services/auth";
import { useGetCustomerMeQuery } from "../../redux/services/customer";
import { setShowCustomerMenu } from "../../redux/slices/app.slice";

import CustomerAvatar from "../../assets/customer-avatar.svg";
import LogoutIcon from "../../assets/logout.svg";

import * as styles from "./CustomerMenu.module.css";

const CustomerMenu = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const showToast = useContext(ToastContext);

  const open = useSelector((s) => s.app.showCustomerMenu);

  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined"
      ? window.matchMedia("(max-width: 768px)").matches
      : false,
  );

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const handler = (e) => setIsMobile(e.matches);
    setIsMobile(mq.matches);
    if (mq.addEventListener) mq.addEventListener("change", handler);
    else mq.addListener(handler);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", handler);
      else mq.removeListener(handler);
    };
  }, []);
  const reduxUser = useSelector((s) => s.user.user);
  const { data: profile } = useGetCustomerMeQuery(undefined, {
    skip: !localStorage.getItem("access_token"),
  });

  const merged = profile || reduxUser || {};
  const fullName = merged.full_name || "";
  const firstName = fullName ? fullName.trim().split(/\s+/)[0] : "";
  const greetingName = firstName || "Customer";
  const email = merged.email || "";

  const [logout, { isSuccess: isLogoutSuccess, isError, error }] =
    useLogoutMutation();

  const closeMenu = () => dispatch(setShowCustomerMenu(false));

  const goTo = (path) => {
    closeMenu();
    navigate(path);
  };

  const handleLogout = () => {
    logout();
    closeMenu();
  };

  useEffect(() => {
    if (isLogoutSuccess) {
      showToast?.("success", "Success", "Logged out successfully");
      navigate("/student/login");
    }
  }, [isLogoutSuccess]);

  useEffect(() => {
    if (isError) {
      showToast?.("error", error?.status, error?.data?.message);
    }
  }, [isError]);

  return (
    <Sidebar
      visible={open}
      position={isMobile ? "top" : "right"}
      onHide={closeMenu}
      showCloseIcon={false}
      dismissable
      modal={false}
      className={`${styles.sidebar} ${isMobile ? styles.sidebarTop : ""}`}
      blockScroll={false}
    >
      <div className={styles.userRow}>
        <div className={styles.avatar}>
          <img src={CustomerAvatar} alt="" className={styles.avatarIcon} />
        </div>
        <div className={styles.userText}>
          <span className={styles.greeting}>
            Hi, {greetingName}!<span className={styles.wave}>👋</span>
          </span>
          {email && <span className={styles.email}>{email}</span>}
        </div>
      </div>

      <div className={styles.divider} />

      <nav className={styles.nav}>
        <button
          type="button"
          className={`${styles.navItem} ${
            location.pathname === "/order-status" ? styles.navItemActive : ""
          }`}
          onClick={() => goTo("/order-status")}
        >
          My orders
        </button>
        <button
          type="button"
          className={`${styles.navItem} ${
            location.pathname === "/account" ? styles.navItemActive : ""
          }`}
          onClick={() => goTo("/account")}
        >
          My account
        </button>
        <button
          type="button"
          className={`${styles.navItem} ${
            location.pathname === "/settings" ? styles.navItemActive : ""
          }`}
          onClick={() => goTo("/settings")}
        >
          Settings
        </button>
        <button
          type="button"
          className={`${styles.navItem} ${styles.logout}`}
          onClick={handleLogout}
        >
          <img src={LogoutIcon} alt="" className={styles.logoutIcon} />
          <span>Log out</span>
        </button>
      </nav>
    </Sidebar>
  );
};

export default CustomerMenu;
